<template>
  <div class="outer-container">
    <div class="container">
      <div>
        Вам отправлен документ для просмотра и подписания через сервис 
        <b> AvisSIGN - подписание электронных документов </b>
      </div>
      <div class="container" style="align-items: start; max-width: 500px;">
        <span>
          🇷🇺 Полное соответствие законодательству РФ
        </span>
        <span>
          🛡 Надёжная многоуровневая защита подписанного документа
        </span>
        <span>
          ✅ Кликая кнопку ПРОДОЛЖИТЬ вы соглашаетесь с Пользовательским соглашением и Политикой конфиденциальности
        </span>
      </div>
      <v-flex class="d-flex justify-center align-center pb-4">
        <v-checkbox v-model="checkbox" style="padding: 0;"/>
        <div>
          Я принимаю
          <a href="https://www.avissign.com/policy/license/" target="_blank" >Пользовательское соглашение</a>
          и
          <a href="https://www.avissign.com/policy/privacy" target="_blank">Политику конфиденциальности</a>
          AvisSIGN.
        </div>
      </v-flex>
      <v-btn
        color="#009933"
        tile
        class="my-2"
        :disabled="!checkbox"
        @click="$emit('confirmed')"
      >
        <div style="color: white;">
          ПРОДОЛЖИТЬ
        </div>
      </v-btn>
      <a href="https://www.avissign.com" target="_blank">www.avissign.com</a>
    </div>
  </div>
</template>

<script>
 export default {
  data: () => {
    return {
      checkbox: false,
    }
  },
  methods: {
  }
 }
</script>

<style scoped>
  /* ✅ Внешний контейнер: занимает всё доступное пространство и скроллится */
  .outer-container {
    height: calc(100vh - 4rem);
    height: calc(100dvh - 4rem);
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    box-sizing: border-box;
  }

  /* ✅ Внутренний контейнер: контент по центру, скроллится при необходимости */
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin: auto;
  }
</style>